import React from 'react'

import { Flex } from '@chakra-ui/react'

//UI
import { SectionHeader } from '@/components/Elements'
import { Textarea, VersionFileInput } from '@/components/Form'

//State

//Helper

//Constant
import { OfferDocumentTypes } from '@/features/offers/constants'
import CollapsibleCard from '@/components/Elements/CollapsibleCard'
import { useCostBudgetAccess } from './CostBudgetAccessProvider'

const CostBudgetInternalDocumentSection = ({ costBudgetIndex }) => {
  const { canEditInternalDocuments } = useCostBudgetAccess()

  return (
    <CollapsibleCard title={'Internal'} defaultIsOpen={true}>
      <Flex direction={'column'} gap="2">
        <Flex>
          <VersionFileInput
            name={`sourcing.costBudgets.${costBudgetIndex}.detail.internalDocuments`}
            label={'Internal Documents '}
            fileType={OfferDocumentTypes.SOURCING_INTERNAL_DOCUMENT}
            canUpload={canEditInternalDocuments}
            isMultiple
            showVersion={false}
            isRequired={false}
          />
        </Flex>

        <Flex p="2">
          <Textarea
            name={`sourcing.costBudgets.${costBudgetIndex}.detail.internalRemark`}
            label={'Internal Remark'}
            disabled={!canEditInternalDocuments}
            isRequired={false}
          />
        </Flex>
      </Flex>
    </CollapsibleCard>
  )
}

export default CostBudgetInternalDocumentSection
